import XSortDropDown from "./XSortDropDown";
import XFilterDropDown from "./XFilterDropDown";
import React, { useEffect, useMemo, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import moment from "moment";
import { truncate } from "lodash";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { selectRemindBarShow } from "features/metadesk/redux/globalState/globalState.selector";
import { useSelector } from "react-redux";
// import useGetXFeed from "./hooks/useGetXFeed";

export default function XFeed() {
  const [hovered, setHovered] = useState(null);
  const [totalSelectedFilterAmount, setTotalSelectedFilterAmount] = useState(0);
  const [filters, setFilters] = useState({});
  const { formatMessage } = useIntl();
  const remindBarShow = useSelector(selectRemindBarShow);
  // const { feed, isLoading, sort, setSort } = useGetXFeed();

  // tmp mock data
  const feed = [
    {
      _id: "677f909feb9ccc7f1f4bc927",
      impressions: 25907,
      likes: 1728,
      comments: 938,
      reposts: 258,
      bookmarks: 233,
      postLink: "x.com/metacrm_inc?test-id=363413119271506700",
      author: {
        _id: "6710bfa04ef272a7b3373e58",
        username: "CoinMarketCap",
        __v: 0,
        created: "2024-10-17T07:41:20.483Z",
        id: "2260491445",
        image:
          "https://pbs.twimg.com/profile_images/1609596934557429760/lIbH-TCC_normal.jpg",
        name: "CoinMarketCap",
        updated: "2024-10-17T07:41:20.483Z",
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=363413119271506700. Here's some content to make it interesting.",
      postDate: "2024-12-31T06:08:51.338Z",
      __v: 0,
      engagement: 3157,
    },
    {
      _id: "677f909feb9ccc7f1f4bc926",
      impressions: 25203,
      likes: 1828,
      comments: 922,
      reposts: 259,
      bookmarks: 233,
      postLink: "x.com/metacrm_inc?test-id=375643549261302850",
      author: {
        _id: "6710bf9f4ef272a7b3373db4",
        username: "binance",
        __v: 0,
        created: "2024-10-17T07:41:19.406Z",
        id: "877807935493033984",
        image:
          "https://pbs.twimg.com/profile_images/1744289390736613378/alcfxov3_normal.jpg",
        name: "Binance",
        updated: "2024-11-27T07:18:14.537Z",
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=375643549261302850. Here's some content to make it interesting.",
      postDate: "2025-01-03T18:24:17.825Z",
      __v: 0,
      engagement: 3242,
    },
    {
      _id: "677f909feb9ccc7f1f4bc928",
      impressions: 26082,
      likes: 1834,
      comments: 968,
      reposts: 243,
      bookmarks: 249,
      postLink: "x.com/metacrm_inc?test-id=55542976880812220",
      author: {
        _id: "6710d0214ef272a7b3441c00",
        username: "dogecoin",
        __v: 0,
        created: "2024-10-17T08:51:45.603Z",
        id: "2235729541",
        image:
          "https://pbs.twimg.com/profile_images/378800000857919980/lHqPIZza_normal.png",
        name: "Dogecoin",
        updated: "2024-11-27T07:31:40.265Z",
      },
      text: "Sample post text related to x.com/metacrm_inc?test-id=55542976880812220. Here's some content to make it interesting.",
      postDate: "2024-12-30T09:39:50.131Z",
      __v: 0,
      engagement: 3294,
    },
  ];
  const [sort, setSort] = useState({});
  const isLoading = false;

  function formatNumber(num) {
    if (num < 1000) return num.toString();

    const units = ["K", "M", "B"];
    let unitIndex = -1;
    let formattedNum = num;

    while (formattedNum >= 1000 && unitIndex < units.length - 1) {
      formattedNum = Math.floor(formattedNum / 1000);
      unitIndex++;
    }

    return formattedNum + units[unitIndex];
  }

  const filterFeed = useMemo(() => {
    if (totalSelectedFilterAmount === 0) return feed;

    const kolFilters = filters.kol || [];

    return feed.filter((item) => kolFilters.includes(item.author.name));
  }, [feed, filters, totalSelectedFilterAmount]);

  const renderSkelton = () => (
    <Box bgcolor="white" borderRadius="4px" p="16px" mb="12px">
      <Box className="item-flex" mb="13px">
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ mr: "9px" }}
        />
        <Box>
          <Skeleton
            variant="rounded"
            width={91}
            height={14}
            sx={{ mb: "6px" }}
          />
          <Skeleton variant="rounded" width={74} height={10} />
        </Box>
      </Box>
      {/* For other variants, adjust the size with `width` and `height` */}
      <Skeleton variant="rounded" width={120} height={10} sx={{ mb: "14px" }} />
      <Skeleton
        variant="rounded"
        width={"100%"}
        height={10}
        sx={{ mb: "8px" }}
      />
      <Skeleton
        variant="rounded"
        width={"100%"}
        height={10}
        sx={{ mb: "8px" }}
      />
      <Skeleton variant="rounded" width={"100%"} height={128} />
    </Box>
  );

  return (
    <Box
      sx={{
        bgcolor: "#D3E8E7",
        p: "16px 16px",
        width: "287px",
        borderRadius: "8px",
        flexShrink: 0,
        position: "sticky",
        right: "20px",
        top: remindBarShow ? "60px" : "0px",
        height: remindBarShow ? "calc(100vh - 70px)" : "calc(100vh - 20px)",
        "@media (max-width: 768px)": {
          display: "none",
        },
      }}
    >
      <Box
        mb="9px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box fontSize={20}>{formatMessage({ id: "global.section.posts" })}</Box>
        <Box className="item-flex" sx={{ gap: "10px" }}>
          <XSortDropDown sortKey={sort} setSortKey={setSort} />
          <XFilterDropDown
            list={feed.map((item) => item.author)}
            selectedFilters={filters}
            setSelectedFilters={setFilters}
            totalSelectedFilterAmount={totalSelectedFilterAmount}
            setTotalSelectedFilterAmount={setTotalSelectedFilterAmount}
          />
        </Box>
      </Box>
      {isLoading ? (
        <>
          {renderSkelton()}
          {renderSkelton()}
        </>
      ) : (
        <Box sx={{ maxHeight: "calc(100vh - 140px)", overflowY: "auto" }}>
          {filterFeed?.map((item, index) => {
            const {
              author,
              text,
              postLink,
              postDate,
              likes,
              comments,
              reposts,
              image: postImage,
              impressions,
              bookmarks,
            } = item;
            const {
              name: authorName,
              username: authorUsername,
              image: authorImage,
            } = author;

            return (
              <Link
                to={
                  postLink.includes("https://")
                    ? postLink
                    : "https://" + postLink
                }
                target="_blank"
                rel="noreferrer noopener"
                key={index}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
              >
                <Box
                  width={"100%"}
                  borderRadius="4px"
                  bgcolor={"#FFF"}
                  p="16px"
                  mb="12px"
                  cursor="pointer"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb="9px"
                  >
                    <Box display="flex" alignItems="center">
                      <img
                        src={authorImage}
                        width={24}
                        height={24}
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                      <Box ml="9px">
                        <Box
                          mr="4px"
                          fontSize={12}
                          color="#555"
                          fontWeight={700}
                        >
                          {truncate(authorName, { length: 15 })}
                        </Box>
                        <Box fontSize="10px" color="#777">
                          @{truncate(authorUsername, { length: 15 })}
                        </Box>
                      </Box>
                    </Box>
                    {hovered === index ? (
                      <Box
                        sx={{ display: "flex", alignItems: "center" }}
                        color="#7B61FF"
                        fontSize={10}
                      >
                        <Box mr="4px">See On X</Box>
                        <i
                          className="meta-crm-icon-ic_arrow_go font-size-14"
                          style={{ marginBottom: "2px" }}
                        />
                      </Box>
                    ) : (
                      <Box color="#A5A5A5" fontSize={10}>
                        {moment(postDate).fromNow()}
                      </Box>
                    )}
                  </Box>

                  <Box
                    className="line-clamp-5"
                    mb="6px"
                    color="#777"
                    sx={{ wordBreak: "break-word" }}
                  >
                    {text}
                  </Box>
                  {postImage && (
                    <Box
                      component={"img"}
                      src={postImage}
                      sx={{
                        width: "100%",
                        height: "128px",
                        objectFit: "cover",
                        mb: "10px",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                  <Box
                    className="item-flex"
                    sx={{
                      justifyContent: "space-between",
                      color: "#777",
                      fontSize: "10px",
                    }}
                  >
                    <Box className="item-flex" gap="2px">
                      <img
                        src={require("assets/img/twitterComment.svg").default}
                      />
                      <Box pt="1px">{formatNumber(comments)}</Box>
                    </Box>
                    <Box className="item-flex" gap="2px">
                      <img
                        src={require("assets/img/twitterRetweet.svg").default}
                      />
                      <Box pt="1px">{formatNumber(reposts)}</Box>
                    </Box>
                    <Box className="item-flex" gap="2px">
                      <img
                        src={require("assets/img/twitterLike.svg").default}
                      />
                      <Box pt="1px">{formatNumber(likes)}</Box>
                    </Box>
                    <Box className="item-flex" gap="2px">
                      <img
                        src={require("assets/img/twitterActivity.svg").default}
                      />
                      <Box pt="1px">{formatNumber(impressions)}</Box>
                    </Box>
                    <Box className="item-flex" gap="2px">
                      <img
                        src={require("assets/img/twitterBookmark.svg").default}
                      />
                      <Box pt="1px">{formatNumber(bookmarks)}</Box>
                    </Box>
                  </Box>
                </Box>
              </Link>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
